import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "tailwindcss/tailwind.css";
import { consumeBlockWatchToken } from "./utils/auth-token";

// 必须在 Vue 和路由开始渲染前恢复跨域传入的登录态。
consumeBlockWatchToken();

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "animate.css/animate.compat.css";
import "wowjs/css/libs/animate.css";
import request from "./utils/request";
import VueScreen from "vue-screen";
import "bootstrap-icons/font/bootstrap-icons.css";
import SlideVerify from "vue-monoplasty-slide-verify";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(VueScreen, "tailwind");
Vue.use(SlideVerify);

Vue.prototype.$url = request.urls;

import VueI18n from "vue-i18n";
import messages from "@/locale/index";

let i18nConfig = {
  locale: store.state.isLang,
  messages,
  silentTranslationWarn: false,
};
Vue.use(VueI18n);
export const i18n = new VueI18n(i18nConfig);

import Toast from "vue2-toast";
import "vue2-toast/lib/toast.css";

Vue.use(Toast);

import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    toolbar: false,
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
